import { render, staticRenderFns } from "./DetailsAdmin.vue?vue&type=template&id=a998a0e2&scoped=true&"
import script from "./DetailsAdmin.vue?vue&type=script&lang=js&"
export * from "./DetailsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DetailsAdmin.vue?vue&type=style&index=0&id=a998a0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a998a0e2",
  null
  
)

export default component.exports